import React, { ReactElement } from 'react'

import { Box, Flex } from '@mindfulchefuk/design-system'
import { RecipeInstructionTitle } from '@mindfulchefuk/features/Recipes/components/RecipeInstructions/RecipeInstructionTitle'
import { RecipeBulletpointSteps } from '@mindfulchefuk/features/Recipes/components/RecipeInstructions/RecipeBulletpointSteps'
import { RecipeStep } from '@mindfulchefuk/features/Recipes/interfaces'
import sortBy from '@mindfulchefuk/utils/sortBy'

type TSortedRecipeInstructionsWithTitles = {
  instructions: RecipeStep[]
}

export const SortedRecipeInstructionsWithTitles = ({
  instructions,
}: TSortedRecipeInstructionsWithTitles): ReactElement => {
  return (
    <Box>
      <Box padding={20} data-testid="recipe-instructions-with-titles">
        {instructions
          .sort((a, b) => sortBy(a?.position, b?.position))
          .map((section) => (
            <Box>
              <Flex direction="row" justifyContent="space-between" mb={12}>
                <RecipeInstructionTitle title={section.title} />
              </Flex>
              <RecipeBulletpointSteps steps={section.description} />
            </Box>
          ))}
      </Box>
    </Box>
  )
}
